import { useState, useEffect } from 'react'
import { toast } from "react-toastify"
import { adjustPageAfterDeletion, handleTrimmedValue, requiredMessage, } from '../../../../Utils'
import useReduxStore from '../../../../hooks/useReduxStore'
import { ADD_TEMPLATE_CATEGORY, DELETE_TEMPLATE_CATEGORY, TEMPLATEL_CATEGORY_LIST, TEMPLATE_CATEGRORY_STATUS_CHANGE, UPDATE_TEMPLATE_CATEGORY } from '../../../../repository/setup'
// import {medicalCategoryList, medicalCategoryDetails, activeInactiveMedicalCategory, addMedicalCategory, updateMedicalCategory, deleteMedicalCategory } from '../../../repository/master-repo'
const useTemplateCategory = () => {
    const [spinner, setSpinner] = useState(false)
    const [totalCount, settotalCount] = useState(0)
    const [controller, setController] = useState({ page: 1, rowsPerPage: 10, searchPage: 1 })
    const [categoryList, setCategoryList] = useState([])
    const { selector: user } = useReduxStore("auth")
    const [filter, setFilter] = useState({ search: "" })

    // -------------Form Section------------------
    const [categoryInputs, setCategoryInputs] = useState({
        name: "",
    })

    const [categoryError, setCategoryError] = useState({})
    const [categoryModal, setCategoryModal] = useState({
        open: false,
        data: null
    })

    const [deleteModal, setDeleteModal] = useState({
        open: false,
        data: null
    })

    const clearForm = () => {
        setCategoryInputs(
            {
                name: "",
            }
        )
        setCategoryError({})
    }

    useEffect(() => {
        getCategoryListData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [controller])

    const getCategoryListData = async () => {
        try {
            let payload = {
                clinicId: user?.clinic_id,
                count: controller.rowsPerPage,
                page: controller.page,
                searchName: filter?.search?.trim(),
                isDeleted: false
            }
            setSpinner(true)
            let response = await TEMPLATEL_CATEGORY_LIST(payload)
            setCategoryList(response?.data)
            settotalCount(response.count)
        } catch (error) {
            toast.error(error?.message)
            setCategoryList([])
            settotalCount(0)
        }
        setSpinner(false)
    }

    // apply Filter
    const ApplyFilter = () => {
        setController((pre) => ({ ...pre, searchPage: pre?.page, page: 1 }))
    }
    // Reset Filter
    const resetFilter = () => {
        setController((pre) => ({ ...pre, page: pre.searchPage, searchPage: 1 }))
        setFilter({ search: "" })
    }

    // Status toggle method
    const status = async (e, Id) => {
        setSpinner(true)
        try {
            let payload = {
                id: Id,
                isActive: e.target.checked,
            }
            let response = await TEMPLATE_CATEGRORY_STATUS_CHANGE(payload)
            getCategoryListData()
            toast.success(response?.message)
        } catch (err) {
            toast.error(err.message)
        }
        setSpinner(false)
    }


    // ---------------------Form Functnality-----------------------------

    // handle Input
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        const finalValue = handleTrimmedValue(value);
        setCategoryInputs((prevProps) => ({ ...prevProps, [name]: finalValue }));
        setCategoryError((pre) => {
            if (typeof finalValue === "string" && finalValue.length === 0) {
                return { ...pre, [name]: "This field cannot be empty or contain only spaces." };
            }
            delete pre[name];
            return { ...pre };
        });
    };

    const handleBlur = (event) => {
        const { name, value } = event.target
        !value?.trim()?.length && setCategoryError((pre) => ({ ...pre, [name]: errorMessage[name] }))
    }

    // Error Message
    const errorMessage = {
        name: requiredMessage('name'),
    }

    // Error hendling
    const isValid = () => {
        const errorObj = {}
        if (!categoryInputs?.name) {
            errorObj['name'] = errorMessage['name']
        }
        setCategoryError(errorObj)
        return !Object.keys(errorObj)?.length
    }

    // Handle add submit data..!
    const handleAddSubmit = async (event) => {
        event.preventDefault()
        if (!isValid()) return
        setSpinner(true)
        let payload = {
            name: categoryInputs?.name,
            clinicId: user?.clinic_id,
        }
        try {
            let response = await ADD_TEMPLATE_CATEGORY(payload)
            setCategoryModal({ data: null, open: false })
            clearForm()
            getCategoryListData()
            toast.success(response.message)

        } catch (err) {
            toast.error(err.message)
        }
        setSpinner(false)
    }

    // Handle Update submit data..!
    const handleupdateSubmit = async (event) => {
        event.preventDefault()
        if (!isValid()) return
        setSpinner(true)
        try {
            let payload = {
                id: categoryModal?.data.id,
                isActive: categoryModal?.data.isActive,
                name: categoryInputs?.name,
                isDeleted: false,
                clinicId: user?.clinic_id,
            }
            let response = await UPDATE_TEMPLATE_CATEGORY(payload)
            toast.success(response.message)
            setCategoryModal({ data: null, open: false })
            clearForm()
            getCategoryListData()
        } catch (err) {
            toast.error(err.message)
        }
        setSpinner(false)
    }

    // Handle delete category..!
    const handleDelete = async (event) => {
        setSpinner(true)
        let payload = {
            id: deleteModal?.data?.id,
            isDeleted: true
        }
        try {
            let response = await DELETE_TEMPLATE_CATEGORY(payload)
            setDeleteModal({ data: null, open: false })
            adjustPageAfterDeletion({
                totalCount: totalCount,
                currentPage: controller.page,
                rowsPerPage: controller.rowsPerPage,
                onPageChange: (newPage) => setController((prev) => ({ ...prev, page: newPage })),
                onTotalCountChange: (newTotal) => settotalCount(newTotal),
            });
            await getCategoryListData()
            toast.success(response.message)
        } catch (err) {
            toast.error(err.message)
        }
        setSpinner(false)
    }


    return {
        data: {
            spinner,
            controller,
            totalCount,
            categoryList,
            filter,
            deleteModal,
            // ---------------Form data
            categoryModal,
            categoryInputs,
            categoryError,
        },
        methods: {
            settotalCount,
            setController,
            setCategoryList,
            setCategoryInputs,
            setCategoryError,
            status,
            setFilter,
            ApplyFilter,
            resetFilter,
            setDeleteModal,
            // -----------------------Form methods ---------------
            setCategoryModal,
            handleInputChange,
            handleBlur,
            handleAddSubmit,
            handleupdateSubmit,
            handleDelete,
            clearForm
        }
    }
}

export default useTemplateCategory
